import CCIconPlaceholderImageMedium from '../../../../Icon/Placeholder/Image/Medium';

export default function CCPlaceholderImagePictureMedium() {
  return (
    <div className="rounded-sm bg-white flex flex-row h-full items-center justify-center w-12 h-12">
      <CCIconPlaceholderImageMedium/>
    </div>
  );
}
